import React from 'react'
import { Button, Row, Col, Form } from '@themesberg/react-bootstrap'

import ProvidersList from '../ProvidersList'

const AddRestrictedProviders = ({
  unRestrictedItems,
  limit,
  page,
  setLimit,
  setPage,
  totalPages,
  addProvider,
  selectedProviders,
  removeProvider,
  addRestrictedProvider,
  search,
  setSearch
}) => {
  return (
    <>
      <Row>
        <Col xs={4}>
          <Form.Label>
            <h5>Providers you add will appear here</h5>
          </Form.Label>
        </Col>

        <Col className='text-right'>
          <Button
            variant='outline-success'
            className='f-right'
            disabled={selectedProviders.count === 0}
            onClick={addRestrictedProvider}
          >
            Submit
          </Button>
        </Col>
      </Row>

      <ProvidersList
        disablePagination
        provider={selectedProviders}
        hasActions
        hasRemoveGamesAction
        removeProvider={removeProvider}
      />

      <Row className='mt-3 mb-2'>
        <Col xs={4}>
          <Form.Label>
            <h5>Unrestricted Providers</h5>
          </Form.Label>
        </Col>
        <Col className='d-flex justify-content-end'>
          <Form.Control
            type='search'
            name='search'
            placeholder='Search Provider'
            style={{ width: '270px' }}
            size='sm'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>

      <ProvidersList
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        provider={unRestrictedItems}
        totalPages={totalPages}
        hasActions
        hasAddGamesAction
        addProvider={addProvider}
      />
    </>
  )
}

export default AddRestrictedProviders
